// import required libraries
import $ from 'jquery';

// import components/functions that run on every page
// import renderSiteSearch from './actions/renderSiteSearch';
import scaleUp from './animations/scaleUp';
import fadeInFadeOutOnScroll from './animations/fadeInFadeOutOnScroll';
// NOTE: will enable draw svg function if we have time to redraw the svgs
// import drawPageSvgs from './animations/drawPageSvgs';
import renderMainNav from './components/MainNav/actions/renderMainNav';
import fontSizeAdjustment from './actions/mobileFontSizeAdjustment';
import flyOutCaptions from './components/flyOutCaptions';

// Import Pages
import accessibility from './actions/accessibility';
import BlogSingle from './pages/BlogSingle';
import ResourceSingle from './pages/ResourceSingle';
import Page404 from './pages/Page404';
import BlogsIndex from './pages/BlogsIndex';
import PressReleaseSingle from './pages/PressReleaseSingle';
import ResourcesIndex from './pages/ResourcesIndex';
import ProgramSingle from './pages/ProgramSingle';
import PressReleaseIndex from './pages/PressReleaseIndex';
import SuccessStoriesIndex from './pages/SuccessStoriesIndex';
import EventsIndex from './pages/EventsIndex';

// import block functions
import renderTabsBlock from './actions/renderTabsBlock';
import testimonialSlider from './components/testimonialSlider';
import StatsBlock from './components/StatsBlock';
import CtaScrollSectionImages from './components/CtaScrollSectionImages';
import heroSlider from './components/hero-slider';
import renderFeaturedVideo from './components/FeaturedVideo/actions/renderFeaturedVideo';
import valueProposition from './components/valueProposition';
import relatedContent from './components/relatedContent';
import renderPeopleBlock from './actions/renderPeopleBlock';
import renderScrollToLink from './actions/renderScrollToLink';
import renderScrollToFormButton from './actions/renderScrollToFormButton';
import successStories from './components/successStories';

// call page specific functions
BlogSingle();
BlogsIndex();
Page404($);
ResourcesIndex();
ResourceSingle();
ProgramSingle();
PressReleaseIndex();
PressReleaseSingle();
SuccessStoriesIndex();
EventsIndex();

// call block functions
testimonialSlider();
StatsBlock($);
heroSlider($);
CtaScrollSectionImages();
renderFeaturedVideo();
renderTabsBlock($);
valueProposition();
relatedContent();
renderPeopleBlock();
successStories();

// call global functions
accessibility();
renderMainNav();
// drawPageSvgs();
scaleUp();
fadeInFadeOutOnScroll($);
renderScrollToLink();
renderScrollToFormButton();
fontSizeAdjustment();
flyOutCaptions();
